import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { clsx } from 'clsx';
import { getTestAttributes, slug } from '@chillibean/component-library';
import { icons } from '@chillibean/component-library/legacy';

import { getFieldTitle } from '../../../__util__/field';

const withInputLabel = (WrappedComponent) => {
  const toReturn = ({ fieldRequired, fieldText, tooltip, withoutPadding = false, ...props }) => {
    return (
      <div
        className={clsx({
          'form__field-wrapper': !withoutPadding,
        })}
        {...getTestAttributes(`form-field-${slug(`${getFieldTitle(fieldRequired, fieldText)}`)}`)}
      >
        {fieldText && (
          <div className="form__field-label">
            <p>{getFieldTitle(fieldRequired, fieldText)}</p>
            {tooltip && (
              <>
                <ReactTooltip place="top" type="dark" effect="solid" backgroundColor="#6A6863" />
                <i
                  data-tip={`<p class='reactTooltip'><span class='reactTooltip__header'>Input guidance:</span>${tooltip}</p>`}
                  data-offset="{'top': 0, 'left': 0}"
                  data-html
                >
                  {icons.questionMark(25, 19, '#FFFFFF', '#626262')}
                </i>
              </>
            )}
          </div>
        )}
        <WrappedComponent fieldRequired={fieldRequired} {...props} />
      </div>
    );
  };

  toReturn.displayName = 'withErrorWrap';
  return toReturn;
};

withInputLabel.propTypes = {
  WrappedComponent: PropTypes.element,
};

export default withInputLabel;
